module.exports = __webpack_public_path__ + "img/IMG_8457.556c9154.jpg";